import { z } from 'zod'

/**
 * Shared one-shot CMS connection package. Secrets are returned exactly once
 * on POST (contentApiKey + webhookSecret) and must never be re-fetched.
 */
export const zCmsConnectionBase = z.object({
  apiBaseUrl: z.string(),
  tenantSlug: z.string(),
  contentApiKey: z.string(),
  webhookSecret: z.string(),
  webhookUrl: z.string(),
  events: z.array(z.string()),
  plugin: z.string(),
  version: z.number(),
})

/**
 * Channel-specific extras. All optional; server may omit any of them.
 * `.passthrough()` on the full connection still accepts unknown future fields.
 */
export const zCmsConnectionExtras = z.object({
  shopDomain: z.string().optional(),
  instanceId: z.string().optional(),
  ghostSiteUrl: z.string().optional(),
  publicHost: z.string().optional(),
  // Squarespace: server-fixed "/blog", never a form input
  basePath: z.string().optional(),
  publicBlogBaseUrl: z.string().optional(),
  hostBlogBaseUrl: z.string().optional(),
  recommendedUrlTemplate: z.string().optional(),
  siteUrl: z.string().optional(),
})

export const zCmsConnection = zCmsConnectionBase.merge(zCmsConnectionExtras).passthrough()
export type CmsConnection = z.infer<typeof zCmsConnection>

export const zCmsConnectionResponse = z.object({
  connection: zCmsConnection,
})
export type CmsConnectionResponse = z.infer<typeof zCmsConnectionResponse>
